import { TableBodyCell, TableCellText } from '@pocketlaw/tetris';
export function KeyClientIdCell(props) {
    const { clientId } = props;
    return (<TableBodyCell headers="clientId">
      <TableCellText primary={clientId}/>
    </TableBodyCell>);
}
